class PredictiveSearch extends HTMLElement {
	constructor() {
		super()

		this.input = this.querySelector('input[type="search"]')
		this.predictiveSearchResults = this.querySelector('#predictive-search')
		this.input.addEventListener(
			'input',
			this.debounce((event) => {
				this.onChange(event)
			}, 300).bind(this),
		)
	}

	onChange() {
		const searchTerm = this.input.value.trim()

		if (!searchTerm.length) {
			this.close()
			return
		}

		this.getSearchResults(searchTerm)
	}

	getSearchResults(searchTerm) {
		fetch(
			`/search/suggest.json?q=${searchTerm}&resources[type]=product,collection&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,body,tag`,
		)
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status)
					this.close()
					throw error
				}
				return response.json()
			})
			.then((data) => {
				const { products, collections } = data.resources.results
				this.refresh()
				products
					.filter(({ type }) => type !== 'Addon')
					.forEach((product) => this.generateCard(product))
			})
			.catch((error) => {
				this.close()
				throw error
			})
	}
	removeCard(id) {
		document.querySelector(`a[data-id="${id}"`).remove()
	}
	generateCard(product) {
		const card = document.createElement('a')
		const title = document.createElement('h3')
		title.appendChild(document.createTextNode(product.title))
		card.title = product.title
		card.href = product.url
		const picture = document.createElement('picture')
		const image = document.createElement('img')
		const { alt, height, width, url } = product.featured_image
		image.src = url
		image.alt = alt
		image.width = width
		image.height = height
		picture.appendChild(image)
		const price = document.createElement('span')
		price.classList.add('money')
		price.appendChild(document.createTextNode(`$ ${product.price}`))
		card.appendChild(picture)
		card.appendChild(title)
		card.appendChild(price)
		card.setAttribute('data-id', product.id)
		this.predictiveSearchResults.appendChild(card)
	}
	open() {
		return null
		this.predictiveSearchResults.style.display = 'block'
	}

	refresh() {
		this.predictiveSearchResults.innerHTML = ''
	}

	debounce(fn, wait) {
		let t
		return (...args) => {
			clearTimeout(t)
			t = setTimeout(() => fn.apply(this, args), wait)
		}
	}
}
customElements.define('predictive-search', PredictiveSearch)
